var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isPendingProduct &&
      (_vm.subscription.subscriptionStatus ===
        _vm.subscriptionDetailPendingCancel ||
        _vm.subscription.subscriptionStatus ===
          _vm.subscriptionDetailPendingProductChange)
        ? _c(
            "b-badge",
            {
              staticClass:
                "current-plan-badge mb-2 border-primary text-primary",
              attrs: { variant: "light" }
            },
            [_vm._v(_vm._s(_vm.$t("xCurrentPlan")))]
          )
        : _vm.isPendingProduct
        ? _c(
            "b-badge",
            {
              staticClass: "mb-2 mt-3 border-primary pending-change-badge",
              attrs: { variant: "primary" }
            },
            [_vm._v(_vm._s(_vm.$t("xPendingChange")))]
          )
        : _vm._e(),
      _vm.isPendingProduct
        ? _c("div", { staticClass: "row mb-4" }, [
            _c("div", { staticClass: "col-auto" }, [
              _c("h5", { staticClass: "mb-0 pb-0" }, [
                _c(
                  "span",
                  { attrs: { "data-test-hook": "pending-product-name" } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.subscription.subscriptionPendingProductName
                        ) +
                        " "
                    )
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.isPendingProduct &&
      _vm.subscription.subscriptionStatus ===
        _vm.subscriptionDetailPendingCancel &&
      _vm.hasApparatusesNotOnDealerManagedPlan()
        ? _c("div", { staticClass: "row mb-4" }, [
            _c("div", { staticClass: "col-auto" }, [
              _c("h5", { staticClass: "mb-0 pb-0" }, [
                _c(
                  "span",
                  { attrs: { "data-test-hook": "pending-product-name" } },
                  [_vm._v(" " + _vm._s(_vm.$t("xMobileLinkBasic")) + " ")]
                )
              ])
            ])
          ])
        : !_vm.isPendingProduct
        ? _c("div", { staticClass: "row mb-4" }, [
            _c("div", { staticClass: "col-auto" }, [
              _c("h5", { staticClass: "mb-0 pb-0" }, [
                _c("span", { attrs: { "data-test-hook": "product-name" } }, [
                  _vm._v(
                    " " + _vm._s(_vm.subscription.subscriptionProductName) + " "
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm.subscription.subscriptionStatus ===
      _vm.subscriptionDetailPendingCancel
        ? _c("div", [
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "span",
                  { attrs: { "data-test-hook": "billing-date-header-text" } },
                  [_vm._v(" " + _vm._s(_vm.$t("xPlanStatus")) + " ")]
                )
              ])
            ]),
            !_vm.isPendingProduct
              ? _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "strong",
                      { attrs: { "data-test-hook": "billing-date" } },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("xPendingCancellation")) + " "
                        )
                      ]
                    )
                  ])
                ])
              : _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "strong",
                      { attrs: { "data-test-hook": "billing-date" } },
                      [_vm._v(" " + _vm._s(_vm.$t("xNoPlan")) + " ")]
                    )
                  ])
                ])
          ])
        : _vm._e(),
      _vm.subscription.subscriptionStatus ===
      _vm.subscriptionDetailPendingProductChange
        ? _c("div", [
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "span",
                  { attrs: { "data-test-hook": "billing-date-header-text" } },
                  [_vm._v(" " + _vm._s(_vm.$t("xPlanStatus")) + " ")]
                )
              ])
            ]),
            !_vm.isPendingProduct
              ? _c("div", [
                  _vm.isSameProductDifferentCadence
                    ? _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "strong",
                            { attrs: { "data-test-hook": "billing-date" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("xPendingChanges")) + " "
                              )
                            ]
                          )
                        ])
                      ])
                    : _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "strong",
                            { attrs: { "data-test-hook": "billing-date" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("xPendingDowngrade")) + " "
                              )
                            ]
                          )
                        ])
                      ])
                ])
              : _c("div", [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.$t("xFuturePlan")))])
                    ])
                  ])
                ])
          ])
        : _vm._e(),
      !(
        _vm.isPendingProduct &&
        _vm.subscription.subscriptionStatus ===
          _vm.subscriptionDetailPendingCancel
      )
        ? _c("div", [
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "span",
                  { attrs: { "data-test-hook": "plan-cost-header-text" } },
                  [_vm._v(" " + _vm._s(_vm.$t("xPlanCost")) + " ")]
                )
              ])
            ]),
            _c("div", { staticClass: "row mb-4" }, [
              _c("div", { staticClass: "col" }, [
                _c("strong", { attrs: { "data-test-hook": "plan-cost" } }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        "$" +
                          _vm.subscription.subscriptionCost +
                          " " +
                          _vm.displayPlanCostCycle(
                            _vm.subscription.subscriptionDurationInMonths
                          )
                      ) +
                      " "
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col" }, [
          !_vm.isPendingProduct &&
          (_vm.subscription.subscriptionStatus ===
            _vm.subscriptionDetailPendingCancel ||
            _vm.subscription.subscriptionStatus ===
              _vm.subscriptionDetailPendingProductChange)
            ? _c(
                "span",
                { attrs: { "data-test-hook": "billing-date-header-text" } },
                [_vm._v(" " + _vm._s(_vm.$t("xPlanEndDate")) + " ")]
              )
            : _vm.isPendingProduct &&
              _vm.subscription.subscriptionStatus ===
                _vm.subscriptionDetailPendingCancel
            ? _c(
                "span",
                { attrs: { "data-test-hook": "billing-date-header-text" } },
                [_vm._v(" " + _vm._s(_vm.$t("xChangeEffectiveDate")) + " ")]
              )
            : _vm.isPendingProduct &&
              _vm.subscription.subscriptionStatus ===
                _vm.subscriptionDetailPendingProductChange
            ? _c(
                "span",
                { attrs: { "data-test-hook": "billing-date-header-text" } },
                [_vm._v(" " + _vm._s(_vm.$t("xPlanStartDate")) + " ")]
              )
            : _c(
                "span",
                { attrs: { "data-test-hook": "billing-date-header-text" } },
                [_vm._v(" " + _vm._s(_vm.$t("xNextBillingDate")) + " ")]
              )
        ])
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("strong", { attrs: { "data-test-hook": "billing-date" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm
                    .$moment(_vm.subscription.subscriptionRenewalDate)
                    .format("MM/DD/YYYY")
                ) +
                " "
            )
          ])
        ])
      ]),
      _vm.isPendingProduct &&
      _vm.subscription.subscriptionStatus ===
        _vm.subscriptionDetailPendingCancel
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              (_vm.isHomePremiumSubscription(
                _vm.subscription.subscriptionProductId
              ) ||
                _vm.isSingleGenSubscription(
                  _vm.subscription.subscriptionProductId
                )) &&
              _vm.hasApparatusesNotOnDealerManagedPlan()
                ? _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("div", [
                        _c(
                          "p",
                          {
                            attrs: {
                              "data-test-hook": "display-basic-warning-messages"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("xGeneratorsNotInPlanWarningText")
                                ) +
                                " "
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-icon-button",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.openModal(
                                      "generator-features-modal"
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "far fa-info-circle fa-lg"
                                })
                              ]
                            )
                          ]
                        )
                      ]),
                      _c("GeneratorFeaturesModal")
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.isHomePremiumSubscription(
                _vm.subscription.subscriptionProductId
              ) ||
                _vm.isSingleFMSubscription(
                  _vm.subscription.subscriptionProductId
                )) &&
              _vm.hasApparatusesNotOnDealerManagedPlan()
                ? _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c("div", [
                        _c(
                          "p",
                          {
                            attrs: {
                              "data-test-hook": "display-basic-warning-messages"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("xFuelMonitorsNotInPlanWarningText")
                                ) +
                                " "
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-icon-button",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.openModal(
                                      "fuel-monitor-features-modal"
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "far fa-info-circle fa-lg"
                                })
                              ]
                            )
                          ]
                        )
                      ]),
                      _c("FuelMonitorFeaturesModal")
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        : _c(
            "div",
            {
              staticClass: "accordion mt-4",
              staticStyle: { width: "100%" },
              attrs: { role: "tablist" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "accordion-wrapper",
                  staticStyle: {
                    border: "1px solid lightgrey",
                    padding: "10px",
                    "border-radius": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value:
                            "collapse-premiumPlan-product-pending-" +
                            _vm.isPendingProduct,
                          expression:
                            "'collapse-premiumPlan-product-pending-' + isPendingProduct"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row align-items-center no-gutters" },
                        [
                          _c("div", { staticClass: "col align-items-center" }, [
                            _c("i", {
                              staticClass: "fa-regular fa-circle-info pr-2"
                            }),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("xProductsAndFeatures")))
                            ])
                          ]),
                          _vm._m(0)
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mb-0 pb-0",
                      attrs: {
                        id:
                          "collapse-premiumPlan-product-pending-" +
                          _vm.isPendingProduct
                      }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("hr", { staticClass: "mx-0 px-0" })
                        ])
                      ]),
                      this.subscription.apparatuses.length === 0
                        ? _c("div", [
                            _c("div", { staticClass: "row pb-0" }, [
                              _c("div", { staticClass: "col-0" }, [
                                _c(
                                  "ul",
                                  {
                                    staticStyle: {
                                      "list-style-type": "none",
                                      "padding-inline-start": "20px"
                                    },
                                    attrs: {
                                      id: "productsCoveredSingleHomePremium"
                                    }
                                  },
                                  [
                                    _c("li", { staticClass: "pt-2" }, [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-xmark pr-2"
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("xThereAreNoProductsOnAccount")
                                        ) + " "
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ])
                          ])
                        : _c("div", [
                            _c("div", { staticClass: "row mb-2" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("p", { staticClass: "mb-0 pb-0" }, [
                                  _c(
                                    "strong",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "products-included-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xProductsIncludedInPlan")
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.subscription
                                              .subscriptionProductName
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-0" }, [
                                _c(
                                  "ul",
                                  {
                                    staticStyle: {
                                      "list-style-type": "none",
                                      "padding-inline-start": "16px"
                                    },
                                    attrs: {
                                      id: "productsCoveredSingleHomePremium"
                                    }
                                  },
                                  _vm._l(_vm.subscription.apparatuses, function(
                                    apparatus,
                                    index
                                  ) {
                                    return _c(
                                      "li",
                                      { key: index, staticClass: "mb-2" },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col d-flex align-items-center"
                                            },
                                            [
                                              _c("b-img", {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  src: _vm.getApparatusIcon(
                                                    apparatus.type
                                                  )
                                                }
                                              }),
                                              _c("span", [
                                                _vm._v(_vm._s(apparatus.name))
                                              ])
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "row mt-1 mb-2" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("p", { staticClass: "mb-0 pb-0" }, [
                                  _c(
                                    "strong",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "features-included-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xFeaturesIncludedInPlan")
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.subscription
                                              .subscriptionProductName
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm.isHomePremiumSubscription(
                              _vm.subscription.subscriptionProductId
                            ) ||
                            _vm.isSingleGenSubscription(
                              _vm.subscription.subscriptionProductId
                            )
                              ? _c("div", [
                                  _c("div", { staticClass: "row mb-3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col d-flex align-items-center"
                                      },
                                      [
                                        _c("b-img", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            src: require("@/assets/images/generator.svg")
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-list"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("xFeaturesInDMHsb1")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm.isHomePremiumSubscription(
                              _vm.subscription.subscriptionProductId
                            ) ||
                            _vm.isSingleFMSubscription(
                              _vm.subscription.subscriptionProductId
                            )
                              ? _c("div", [
                                  _c("div", { staticClass: "row mb-3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col d-flex align-items-center"
                                      },
                                      [
                                        _c("b-img", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            src: require("@/assets/images/tank.svg")
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-monitor-list"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xSubFeaturesFmFuelLevelHistoryWarningsBattery"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm.isSingleGenSubscription(
                              _vm.subscription.subscriptionProductId
                            )
                              ? _c("div", [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col icon-and-text" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "far fa-fw fa-circle-check mr-1"
                                        }),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-monitor-list"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xFeaturePremiumMonitoringForOneHsb"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm.isSingleFMSubscription(
                              _vm.subscription.subscriptionProductId
                            )
                              ? _c("div", [
                                  _c("div", { staticClass: "row mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col icon-and-text" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "far fa-fw fa-circle-check mr-1"
                                        }),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-monitor-list"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xSubFeaturesFmMonitorOneFm"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm.isSingleHomeSubscription(
                              _vm.subscription.subscriptionProductId
                            )
                              ? _c("div", [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col icon-and-text" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "far fa-fw fa-circle-check mr-1"
                                        }),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-monitor-list"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xFeatureSingleHomePremiumSubscription3"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm.isMultiHomeSubscription(
                              _vm.subscription.subscriptionProductId
                            )
                              ? _c("div", [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col icon-and-text" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "far fa-fw fa-circle-check mr-1"
                                        }),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-monitor-list"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xSubFeaturesMultiHome2Hsb4FM"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm.apparatusesNeedsAttention !== undefined &&
                            _vm.apparatusesNeedsAttention !== null &&
                            _vm.apparatusesNeedsAttention.length > 0
                              ? _c("div", [
                                  _c("div", { staticClass: "row mt-3 mb-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c("p", { staticClass: "mb-0 pb-0" }, [
                                        _c(
                                          "strong",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-text"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xProductsNotCoveredBy"
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.subscription
                                                    .subscriptionProductName
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-0" }, [
                                      _c(
                                        "ul",
                                        {
                                          staticStyle: {
                                            "list-style-type": "none",
                                            "padding-inline-start": "16px"
                                          },
                                          attrs: { id: "productsNotCovered" }
                                        },
                                        _vm._l(
                                          _vm.apparatusesNeedsAttention,
                                          function(apparatus, index) {
                                            return _c(
                                              "li",
                                              {
                                                key: index,
                                                staticClass: "mb-2"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col d-flex align-items-center"
                                                      },
                                                      [
                                                        _c("b-img", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            src: _vm.getApparatusIcon(
                                                              apparatus.type
                                                            )
                                                          }
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              apparatus.apparatusName
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ])
                                  ]),
                                  _vm.apparatusesNeedsAttention !== undefined &&
                                  _vm.apparatusesNeedsAttention !== null &&
                                  _vm.apparatusesNeedsAttention?.filter(
                                    apparatus =>
                                      apparatus?.type !==
                                      _vm.subscription?.apparatuses[0]?.type
                                  ).length > 0
                                    ? _c("div", [
                                        _c("div", { staticClass: "row mt-0" }, [
                                          _c("div", { staticClass: "col" }, [
                                            _c(
                                              "p",
                                              { staticClass: "mb-0 pb-0" },
                                              [
                                                _c(
                                                  "strong",
                                                  {
                                                    attrs: {
                                                      "data-test-hook":
                                                        "features-included-text"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "xFeaturesNotSupportedInPlan"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.subscription
                                                            .subscriptionProductName
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]),
                                        _vm.apparatusesNeedsAttention !==
                                          undefined &&
                                        _vm.apparatusesNeedsAttention !==
                                          null &&
                                        _vm.apparatusesNeedsAttention.filter(
                                          apparatus =>
                                            apparatus.type ===
                                            _vm.hsbApparatusType
                                        ).length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "row mt-2" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-test-hook":
                                                            "features-included-list"
                                                        }
                                                      },
                                                      [
                                                        _c("b-img", {
                                                          attrs: {
                                                            src: _vm.getApparatusIcon(
                                                              _vm.hsbApparatusType
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "xFeatureNotIncludedFeaturesHSB"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.apparatusesNeedsAttention !==
                                          undefined &&
                                        _vm.apparatusesNeedsAttention !==
                                          null &&
                                        _vm.apparatusesNeedsAttention.filter(
                                          apparatus =>
                                            apparatus.type ===
                                            _vm.fuelTankApparatusType
                                        ).length > 0
                                          ? _c(
                                              "div",
                                              {
                                                class:
                                                  _vm.apparatusesNeedsAttention !==
                                                    undefined &&
                                                  _vm.apparatusesNeedsAttention !==
                                                    null &&
                                                  _vm.apparatusesNeedsAttention.filter(
                                                    apparatus =>
                                                      apparatus.type ===
                                                      _vm.hsbApparatusType
                                                  ).length > 0
                                                    ? "row mt-3"
                                                    : "row mt-2"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-test-hook":
                                                            "features-included-list"
                                                        }
                                                      },
                                                      [
                                                        _c("b-img", {
                                                          attrs: {
                                                            src: _vm.getApparatusIcon(
                                                              _vm.fuelTankApparatusType
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "xFeatureNotIncludedFeaturesFuelTank"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                    ]
                  )
                ],
                1
              ),
              !_vm.isPendingProduct
                ? _c("div", [
                    _vm.subscription.subscriptionStore ==
                    _vm.subscriptionStoreTypesApple
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-test-hook": "manage-plan-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xManagePlanOnApple")) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://account.apple.com/account/manage/section/subscriptions",
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-3",
                                    attrs: {
                                      "data-test-hook": "manage-plan-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "https://account.apple.com/account/manage/section/subscriptions."
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      : _vm.subscription.subscriptionStore ==
                        _vm.subscriptionStoreTypesGoogle
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-test-hook": "manage-plan-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xManagePlanOnGoogle")) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://play.google.com/store/account/subscriptions",
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-3",
                                    attrs: {
                                      "data-test-hook": "manage-plan-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "https://play.google.com/store/account/subscriptions"
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      : _vm._e(),
                    !_vm.hasPartiallyEnrolledTank(_vm.apparatuses) &&
                    (_vm.isSingleApparatusSubscription(
                      _vm.premiumSubscriptionApparatusMultiplePlans
                        ?.subscriptionProductId
                    ) ||
                      (_vm.premiumSubscriptionApparatusMultiplePlans
                        ?.apparatuses.length === 1 &&
                        _vm.subscription.subscriptionStore ===
                          _vm.subscriptionStoreTypesWeb))
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-warning",
                              attrs: {
                                type: "button",
                                title: _vm.$t("xCancelPlanLowercase"),
                                "data-test-hook": "CancelMultiplePlansBtn"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit(
                                    "openCancelPlanMultiplePlansModal"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("xCancelPlanLowercase")) +
                                  " "
                              )
                            ]
                          )
                        ])
                      : !_vm.hasPartiallyEnrolledTank(_vm.apparatuses) &&
                        _vm.subscription.subscriptionStatus !==
                          _vm.subscriptionDetailPendingCancel &&
                        _vm.subscription.subscriptionStatus !==
                          _vm.subscriptionDetailPendingProductChange &&
                        _vm.subscription.subscriptionStore ===
                          _vm.subscriptionStoreTypesWeb
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-warning",
                              attrs: {
                                type: "button",
                                title: _vm.$t("xManageYourPlanBtn"),
                                "data-test-hook": "ManageYourPlanBtn",
                                disabled: this.subscriptionCancelInitiated
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("openManagePlanModal")
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-pencil" }),
                              _vm._v(
                                " " + _vm._s(_vm.$t("xManageYourPlanBtn")) + " "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    !_vm.isSameProductDifferentCadence &&
                    _vm.subscription.subscriptionStatus !==
                      _vm.subscriptionDetailPendingCancel
                      ? _c("div", { staticClass: "row mt-4" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "p",
                              {
                                staticClass: "auto-renew-message text-small",
                                attrs: { "data-test-hook": "AutoRenewMsg" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "xThisSubscriptionWillAutoRenewShortVersion"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ])
                      : _vm._e(),
                    !_vm.hasPartiallyEnrolledTank(_vm.apparatuses) &&
                    _vm.subscription.subscriptionStatus ===
                      _vm.subscriptionDetailPendingProductChange &&
                    _vm.subscription.subscriptionStore ===
                      _vm.subscriptionStoreTypesWeb
                      ? _c("div", { staticClass: "mt-4 pb-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-warning",
                              attrs: {
                                type: "button",
                                title: _vm.$t("xManageYourPlanBtn"),
                                "data-test-hook": "ManageYourPlanBtn",
                                disabled: this.subscriptionCancelInitiated
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("openManagePlanModal")
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-pencil" }),
                              _vm._v(
                                " " + _vm._s(_vm.$t("xManageYourPlanBtn")) + " "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                : _c("div", [
                    _vm.subscription.subscriptionStatus ===
                    _vm.subscriptionDetailPendingProductChange
                      ? _c("div", { staticClass: "row mt-4" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "p",
                              {
                                staticClass: "auto-renew-message text-small",
                                attrs: { "data-test-hook": "AutoRenewMsg" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "xThisSubscriptionWillAutoRenewShortVersion"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
            ]
          )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto" }, [
      _c("i", { staticClass: "fas fa-chevron-down when-closed" }),
      _c("i", { staticClass: "fas fa-chevron-up when-open" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }